import { render, staticRenderFns } from "./FSwitch.vue?vue&type=template&id=60df7b02&"
import script from "./FSwitch.vue?vue&type=script&lang=ts&"
export * from "./FSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports